(ns ui.status-vocab
  "The run-status vocabulary itself, without the components that paint it. The
   backends spell the same states differently — extracts use \"fail\"/\"success\",
   transforms \"failed\"/\"completed\" plus in-flight and queued states.
   Deliberately total: an unrecognised status reads as `:other` rather than
   throwing.")


(defn normalize-status [status]
  (condp contains? status
    #{"fail" "failed"}                             :failed
    #{"success" "succeeded" "completed"}           :succeeded
    #{"running" "pending" "starting" "connecting"} :running
    #{"queued" "queue" "scheduled"}                :queued
    #{"skipped"}                                   :skipped
    :other))
